import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-carbon-graphite border-y border-carbon-line" data-id="element-187" data-mp="1o3x1pk7r0m0y">
      <div className="max-w-4xl mx-auto" data-id="element-188" data-mp="223ekniyd552e">
        <div className="bg-carbon border border-gold rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-189" data-mp="222d797tvk6hi">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold" data-id="element-190" data-mp="1x4uypijrrta1" />
          <div className="inline-flex flex-col items-center justify-center w-28 h-28 rounded-full border-2 border-gold text-gold mb-8" data-id="element-191" data-mp="19fitsuvh67dj">
            <ShieldCheckIcon size={36} data-id="element-192" data-mp="14dtgf8ks5hma" />
            <span className="text-xs font-bold tracking-widest mt-1" data-id="element-193" data-mp="1j4twnzrrqfsz">7 DAYS</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-white" data-id="element-194" data-mp="1edk8z4ps5mjq">
            Complete <span className="text-gold" data-id="element-195" data-mp="qnhlz30q36rz">7-Day</span> Money Back Guarantee
          </h2>
          <div className="space-y-6 text-lg text-mist max-w-2xl mx-auto" data-id="element-196" data-mp="lpg60qylfnkq">
            <p data-id="element-197" data-mp="lnbzs2d82cha">
              Open the entire 6-in-1 teaching system. Explore all the bonuses.
              Use the material in your most challenging class this week.
            </p>
            <p className="font-medium text-white" data-id="element-198" data-mp="twi4gz7u7blr">
              If you feel the material is not clear, practical or useful for
              your teaching needs, contact us within 7 days.
            </p>
            <p className="text-white font-bold text-xl" data-id="element-199" data-mp="12t0t3z91cdcj">
              We will refund <span className="text-gold" data-id="element-200" data-mp="628df2q0knba">100% of your money</span>.
              No questions. No forms. No hassle.
            </p>
            <p className="text-sm text-smoke mt-8" data-id="element-201" data-mp="b1lb6iifbesn">
              Because if the material does not deliver the value we promise, we
              don&apos;t want your money.
            </p>
          </div>
        </div>
      </div>
    </section>;
}